import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import { QuotationContext } from "./context/QuotationContext";
import SelectLevelProducts from "./SelectLevelProducts";
import { db } from "../firebase.config";
import { Snackbar } from "@mui/material";

export default function SelectQuotationLevelProducts() {
    const navigate = useNavigate();
    const location = useLocation(); // Get location to know where to return
    
    const { setSelectedItems } = useContext(QuotationContext);

    const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "info" });

    const handleConfirmSelection = (finalItems) => {
        if (!finalItems || finalItems.length === 0) {
            setSnackbar({
                open: true,
                message: "No items were selected.",
                severity: "error",
            });
            return;
        }

        const itemsWithDefaults = finalItems.map(item => ({
            ...item,
            quantity: item.quantity || 1, 
            price: item.price || 0,
        }));
        setSelectedItems(itemsWithDefaults);

        const returnPath = location.state?.from || '/quotation-templates/qtemplate4';
        navigate(returnPath);
    };

    const handleCancelSelection = () => {
        const returnPath = location.state?.from || '/quotation-templates/qtemplate4';
        navigate(returnPath);
    };

    return (
        <>
            <SelectLevelProducts
                db={db}
                title="Product Selection for Quotation"
                onSave={handleConfirmSelection}
                onCancel={handleCancelSelection}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                message={snackbar.message}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: snackbar.severity === 'success' ? '#4caf50' : '#f44336',
                    },
                }}
            />
        </>
    );
}